import React from "react"
import Tabs from '../Tabs/Tabs';
import ImportsPresenterTabContent from './ImportsPresenterTabContent'
import ModalButtons from '../ModalButtons/ModalButtons'

export default class ImportsPresenter extends React.Component {

  constructor(props) {
    super(props);
    
    this.state = {
      /* ui state */
      active_tab: this.props.validated ? 'failed' : 'created',

      /* paths */
      created_imports_path: this.props.created_imports_path || null,
      failed_imports_path: this.props.failed_imports_path,

      /* helpers */
      date_format: this.props.date_format || null,
      time_format: this.props.time_format || null,
    }
    this.setActiveTab = this.setActiveTab.bind(this)
  }

  render() {
    var buttons = [
      {
        name: I18n.t('ok'),
        html_attributes: [
          'data-dismiss="modal"'
        ]
      },
    ]
    
    return (
      <div className="ImportsBuilder">
        <div className="panel panel-form">
          <ModalButtons loading={this.state.loading} buttons={buttons} />
          <Tabs tabs={this.tabs()}/>
          <ImportsPresenterTabContent {...this.state} />
        </div>
      </div>
    )
  }

  tabs() {
    var tabs = []

    if (this.props.validated){
      tabs.push({
        tabName: I18n.t('failed'),
        targetName: 'failed',
        classes: this.state.active_tab === 'failed' ? 'active' : null,
        changeHandler: this.setActiveTab,
      })
    } else {
      tabs.push({
        tabName: I18n.t('created'),
        targetName: 'created',
        classes: this.state.active_tab === 'created' ? 'active' : null,
        changeHandler: this.setActiveTab,
      })
    }

    return tabs;
  };

  setActiveTab(tab) {
    this.setState({
      active_tab: tab
    })
  }
}
